import type { PurchaseUncheckedCreateInputSchema, PurchaseUncheckedUpdateInputSchema } from "@repo/types";
import type { z } from "zod";
import { db } from "../client";


export async function getPurchaseById(id: string) {
	return db.purchase.findUnique({
		where: { id, isDeleted: false },
	});
}

export async function getPurchasesByOrganizationId(organizationId: string) {
	return db.purchase.findMany({
		where: {
			organizationId,
			isDeleted: false,
			status: "active",
		},
		orderBy: {
			createdAt: "desc",
		},
	});
}

export async function getPurchasesByUserId(userId: string) {
	return db.purchase.findMany({
		where: {
			userId,
			status: "active",
			isDeleted: false,
		},
		orderBy: {
			createdAt: "desc",
		},
	});
}

export async function getPurchaseBySubscriptionId(subscriptionId: string) {
	return db.purchase.findFirst({
		where: {
			subscriptionId,
			isDeleted: false,
		},
		orderBy: {
			createdAt: "desc",
		},
	});
}

export async function createPurchase(
	purchase: z.infer<typeof PurchaseUncheckedCreateInputSchema>,
) {
	const created = await db.purchase.create({
		data: purchase,
	});

	return getPurchaseById(created.id);
}

export async function updatePurchase(
	purchase: z.infer<typeof PurchaseUncheckedUpdateInputSchema> & {
		id: string;
	},
) {
	const data = JSON.parse(JSON.stringify(purchase));
	// biome-ignore lint/performance/noDelete: <explanation>
	delete data.id;
	const updated = await db.purchase.update({
		where: {
			id: purchase.id,
		},
		data,
	});

	return getPurchaseById(updated.id);
}

export async function deletePurchaseBySubscriptionId(subscriptionId: string) {
	await db.purchase.update({
		where: {
			subscriptionId,
		},
		data: {
			isDeleted: true,
		},
	});
}
